import React, { Component } from "react";
import Footer from "../../components/Footer/footer";
import NavbarPage from "../../components/Navbar/Navbar_Page";
import Section from "./section";

class Index1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pos: document.documentElement.scrollTop,
      imglight: false,
      navClass: "",
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    let scrollup = document.documentElement.scrollTop;
    if (scrollup > this.state.pos) {
      this.setState({ navClass: "nav-sticky", imglight: false });
    } else {
      this.setState({ navClass: "", imglight: false });
    }
  };

  render() {
    return (
      <React.Fragment>
        {/* Importing Navbar */}
        <NavbarPage
          navItems={this.state.navItems}
          navClass={this.state.navClass}
          imglight={this.state.imglight}
        />

        {/* Importing section */}
        <Section
          title={"Quick Truck Rental Roodepoort | Same-Day Trucks, Vans & Bakkies"}
          titleTemplate={"QikTruck"}
          titleSeparator={"-"}
          image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
          pathname={"https://qiktruck.co.za/quick-truck-rental-roodepoort"}
          pageHeading={"Quick Truck Rental in Roodepoort"}
          pageSubHeading={"Fast, affordable trucks, vans and bakkies — today"}
          pageDescription={"Need a truck in Roodepoort fast? QikTruck offers quick truck rental for moves, deliveries and business logistics. Book online in minutes, get a vetted driver, transparent pricing and real-time tracking across Roodepoort, Florida, Constantia Kloof, Little Falls and surrounds."}
          pageDescription2={"Choose the right vehicle for your job: 1-ton bakkies, panel vans, 3- to 8-ton trucks and tail-lift options. Perfect for furniture moves, retail deliveries, e-commerce, events and construction. Same-day or scheduled, hourly or day rates, short- or long-term. Get an instant quote and get moving."}
        />

        {/* Importing Footer */}
        <Footer />
      </React.Fragment>
    );
  }
}

export default Index1;
